export const DEFAULT_COLOR = "#000000";
export const FORM_FIELD_ID_PREFIX = "legacy-form";
export const ODATA_LOOKUP_DEBOUNCE_MS = 200;
export const ODATA_LOOKUP_PAGE_SIZE = 20;
export const ODATA_NAME_FIELD = "Name";
export const SAVE_AND_CLOSE_FIELD_NAME = "saveAndClose";
